import { COLORS } from '@/config/colors';
import { css, fillOutlined, circle } from './draw-utils';
import type { ProceduralDef } from '../types';

const ARM = 0x9fd8ea; // translucent cyclone arm

/**
 * B9 Eye of the Storm — air Elemental. A swirling cyclone
 * with a calm bright eye. Frame 0 = calm, frame 1 = gust (arms stretch out
 * as it shoves the air). docs/02 Elementals.
 */
export const bossGaleBody: ProceduralDef = {
  key: 'boss/gale/body',
  width: 150,
  height: 150,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const gust = frame === 1;
    const reach = gust ? 64 : 52;

    // Airy halo
    const halo = ctx.createRadialGradient(c, c, 16, c, c, c);
    halo.addColorStop(0, gust ? 'rgba(214,242,255,0.45)' : 'rgba(214,242,255,0.25)');
    halo.addColorStop(1, 'rgba(214,242,255,0)');
    circle(ctx, c, c, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Three spiral cyclone arms (logarithmic curls)
    const arms = 3;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    for (let i = 0; i < arms; i++) {
      const base = (Math.PI * 2 * i) / arms;
      ctx.beginPath();
      for (let t = 0; t <= 1.0001; t += 0.1) {
        const a = base + t * 3.0;
        const rr = 16 + t * reach;
        const x = c + Math.cos(a) * rr;
        const y = c + Math.sin(a) * rr;
        if (t === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.strokeStyle = css(COLORS.outline);
      ctx.lineWidth = 11;
      ctx.stroke();
      ctx.strokeStyle = css(ARM);
      ctx.lineWidth = 7;
      ctx.stroke();
    }

    // Calm eye — bright still center
    circle(ctx, c, c, 22);
    fillOutlined(ctx, COLORS.galeWind, 5);
    circle(ctx, c, c, 13);
    ctx.fillStyle = css(COLORS.galeCore);
    ctx.fill();
    circle(ctx, c - 4, c - 4, 4);
    ctx.fillStyle = 'rgba(255,255,255,0.9)';
    ctx.fill();
    void h;
  },
};
